module.exports = __webpack_public_path__ + "static/media/tapir-red.967934d8.png";